// extracted by mini-css-extract-plugin
export var arrows = "_61-5";
export var decrementer = "_61-9";
export var disabled = "_61-3";
export var error = "_61-1";
export var hiddenText = "_61-a";
export var incrementer = "_61-8";
export var input = "_61-7";
export var inputWrapper = "_61-0";
export var leadingIcon = "_61-b";
export var readonly = "_61-2";
export var regular = "_61-6";
export var small = "_61-4";